import CorelogicApiService from './CorelogicApiService';

export default class PropertyService extends CorelogicApiService {
  byAddress(address) {
    const data = {
      address,
    };
    return this.get('/PropertySearch/autocomplete', data);
  }
}
